import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import { GET_PACKAGE_BY_ACCOUNT } from 'containers/AccountModule/GraphQL/AccountQuery'
import { SubscriptionClient } from 'SubscriptionClient'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'

interface Props {
  gstComponent: React.ReactElement
  defaultComponent: React.ReactElement
}

export const GSTSubscriptionChecker = ({
  gstComponent,
  defaultComponent,
}: Props) => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  const {
    data: { getPackageByAccount } = { getPackageByAccount: [] },
    loading,
    called,
  } = useQuery(GET_PACKAGE_BY_ACCOUNT, {
    client: SubscriptionClient,
    variables: { softwareCode: 'ACCOUNT', accountID: user?.accountID },
  })

  if (!called || loading) return <Loading />

  return getPackageByAccount.includes('GST') ? gstComponent : defaultComponent
}
